import React, {FC, useState} from "react";
import Typography from "@material-ui/core/Typography";
import {IDam} from "../types/types";
import {Button, Card, CardActions, CardContent, Grid, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText} from "@material-ui/core";
import { useHistory } from "react-router-dom";


interface IDamProps {
    dam: IDam,
    projectAccessLevel: number,
    // update dam callback
    updateDam: (dam: IDam) => void
}

const Dam: FC<IDamProps> = ({dam, updateDam, projectAccessLevel}: IDamProps) => {
    let history = useHistory();


    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

    const handleDeleteClick = (dam: IDam) => {
        setDeleteDialogOpen(true);
    }

    const handleDeleteConfirm = (dam: IDam) => {
        const newDam = { ...dam };
        newDam.is_active = false;
        updateDam(newDam);
        setDeleteDialogOpen(false);
    }

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
    }


    const handleProjectClick = (id: number) => {
        history.push("/assessments/"+id)

    }

    return (
        <Grid item xl={2} lg={3} sm={5} xs={11}>
        <Card>
            <CardContent>
                <Typography color="textSecondary" gutterBottom>
                    Dam
                </Typography>
                <Typography variant="h5" component="h2">
                    {dam.name}
                </Typography>
            </CardContent>
            <CardActions style={{ display: "flex", justifyContent: "space-between" }}>
                { projectAccessLevel >=4  && <Button  variant="outlined" size="small" onClick={prevState => handleDeleteClick(dam)}>Disable</Button> }
                <Button  variant="outlined" size="small" onClick={prevState => handleProjectClick(dam.id || -1)}>Open</Button>
            </CardActions>
        </Card>
        <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel}>
                <DialogTitle>Confirm Disable</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to disable {dam.name}?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={() => handleDeleteConfirm(dam)} color="secondary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    );
}

export default Dam;
